import React from "react";
import RequestorTable from "./RequestorTable";

function RequestorMain() {
  return (
    <>
      {" "}
      <div className="devops-background">
        <RequestorTable />
      </div>
    </>
  );
}

export default RequestorMain;
